import a from "./utils/assignImmutable";
import b from "./utils/clamp";
export default (function (c, d) {
  return a(c, {
    a: b(c.a - c.a * d)
  });
});